import React from "react";
import {
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Chip,
    IconButton,
    Tooltip,
} from "@mui/material";

import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { formatLastContact } from "../../utils/formatLastContact";

function chipSx() {
    return { fontWeight: 800, border: "1px solid var(--border)", bgcolor: "var(--branco)" };
}

function priorityChip(priority) {
    if (priority === "Alta") return <Chip label="Alta" color="error" size="small" />;
    if (priority === "Média") return <Chip label="Média" color="warning" size="small" />;
    return <Chip label="Baixa" size="small" sx={chipSx()} />;
}

function statusChip(status) {
    const base = { size: "small", sx: chipSx() };
    if (status === "Sem resposta") return <Chip label={status} color="error" size="small" />;
    if (status === "Em conversa") return <Chip label={status} color="primary" size="small" />;
    if (status === "Aguardando") return <Chip label={status} color="warning" size="small" />;
    if (status === "Fechado") return <Chip label={status} color="success" size="small" />;
    return <Chip label={status} {...base} />;
}

export default function LeadsTable({ leads, onOpenLead }) {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 1,
                border: "1px solid var(--border)",
                bgcolor: "var(--branco)",
                overflow: "hidden",
            }}
        >
            <Table>
                <TableHead>
                    <TableRow sx={{ bgcolor: "var(--bg)" }}>
                        <TableCell sx={{ fontWeight: 900 }}>Lead</TableCell>
                        <TableCell sx={{ fontWeight: 900 }}>Etapa</TableCell>
                        <TableCell sx={{ fontWeight: 900 }}>Prioridade</TableCell>
                        <TableCell sx={{ fontWeight: 900 }}>Status</TableCell>
                        <TableCell sx={{ fontWeight: 900 }}>Responsável</TableCell>
                        <TableCell sx={{ fontWeight: 900 }}>Último contato</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 900 }}>
                            Ações
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {leads.map((l) => (
                        <TableRow key={l.id} hover>
                            <TableCell>
                                <div style={{ fontWeight: 800 }}>{l.name}</div>
                                <div style={{ color: "var(--cise-text-muted)", fontSize: 13 }}>{l.phone}</div>
                            </TableCell>

                            <TableCell>
                                <Chip label={l.stage} size="small" sx={chipSx()} />
                            </TableCell>

                            <TableCell>{priorityChip(l.priority)}</TableCell>

                            <TableCell>{statusChip(l.status)}</TableCell>

                            <TableCell>{l.owner}</TableCell>

                            <TableCell>{formatLastContact(l.lastMessageAt)}</TableCell>

                            <TableCell align="right">
                                <Tooltip title="Abrir conversa">
                                    <IconButton
                                        size="small"
                                        onClick={() => window.location.assign(`/admin/conversas?open=${l.id}`)}
                                    >
                                        <ChatOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Agendar">
                                    <IconButton size="small" onClick={() => alert("Abrir agenda (futuro)")}>
                                        <EventAvailableOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Detalhes">
                                    <IconButton
                                        size="small"
                                        onClick={() => onOpenLead(l)}
                                    >
                                        <InfoOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Paper>
    );
}